import React, { ReactElement } from 'react';
import { GamesPageState } from 'src/domains/casino/components/games/GamesPage.state';
import { observer } from 'src/utils/mobx-react';
import {
    GamesContentWrapper,
    GamesListVirtualScroll,
    Loader,
    PreloaderBlock,
} from 'src/domains/casino/components/games/GamesPage.style';
import { GameRowProvider } from 'src/domains/casino/components/games/GameRowProvider';
export interface CasinoGamesListPropsType {
    gamesPageState: GamesPageState;
}

export const CasinoGamesList = observer('CasinoGamesList', (props: CasinoGamesListPropsType) => {
    const { gamesPageState } = props;

    const renderGameRow = (index: number): ReactElement | null => {
        if (gamesPageState.filteredGames === 'loading') {
            return null;
        }

        const game = gamesPageState.filteredGames[index];

        if (game === undefined) {
            return null;
        }

        return (
            <GameRowProvider
                key={`${game.provider}-${game.launchId}`}
                game={game}
            />
        );
    };

    return (
        <GamesContentWrapper data-test='casino-table-content'>
            {gamesPageState.filteredGames === 'loading' ? (
                <PreloaderBlock>
                    <Loader data-test='all-games-list-loader' />
                </PreloaderBlock>
            ) : (
                <GamesListVirtualScroll
                    data-test='all-games-list'
                    totalCount={gamesPageState.filteredGames.length}
                    itemContent={(index): ReactElement | null => renderGameRow(index)}
                />
            )}
        </GamesContentWrapper>
    );
});
